import styled, { css } from 'styled-components'
import { colors, sizes } from 'config/ui'

export const Wrapper = styled.div`
  display: flex;
`

export const Content = styled.div`
  ${({ bigScreen, gradient }) => css`
    max-width: ${bigScreen ? 'calc(900px - 350px)' : '300px'};
    padding: 20px;

    > svg {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }

    h2 {
      margin-bottom: 10px;
    }
    p {
      margin-top: 0;
      line-height: 30px;
    }

    > div.slick-slider {
      margin: 20px 0;
    }

    ${!bigScreen &&
      `
      &:before {
        content: '';
        display: block;
        width: 100%;
        height: 60px;
        position: absolute;
        top: -1px;
        left: 0;
        border-top-right-radius: ${sizes.radius}px;
        border-top-left-radius: ${sizes.radius}px;
        background: linear-gradient(to right, ${gradient.top}, ${
        gradient.bottom
      });
      }
    `};
  `};
`

export const ImageWrapper = styled.div`
  ${({ gradient }) => css`
    min-width: 350px;
    padding: 20px 0;
    background: linear-gradient(to bottom, ${gradient.top}, ${gradient.bottom});
    display: flex;
    alig-items: center;
    justify-content: center;

    > img {
      object-fit: contain;
    }
  `};
`

export const Slide = styled.div`
  padding: 20px;
`

export const Footer = styled.div`
  padding: 30px;
  border-top: 1px solid ${colors.lightGray};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Dots = styled.div`
  display: flex;
`

export const Dot = styled.div`
  ${({ active }) => css`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${active ? colors.gray : colors.lightGray};
    margin-right: 10px;
    cursor: pointer;
  `};
`

export const Actions = styled.div`
  display: flex;

  > button {
    margin-left: 20px;
    text-transform: none;
    color: ${colors.black};

    &:disabled {
      background-color: ${colors.lightGray};
      color: ${colors.gray};
      border: 1px solid ${colors.gray};
    }
  }

  > button:first-child {
    margin-left: 0;
  }
`
